import React, { Fragment } from 'react';

import { colors } from 'styles/cp';
import { SaleLine } from 'types/Sale';

type Props = {
  itemLine: SaleLine;
};

const TransactionLineItemQuantity: React.FC<Props> = ({ itemLine }) => {
  return (
    <Fragment>
      <div className="quantity-input">x {itemLine.quantity}</div>
      <style jsx>{`
        .quantity-input {
          width: 100%;
          text-align: center;
          height: 30px;
          color: ${colors.gray03};
        }
      `}</style>
    </Fragment>
  );
};

export default TransactionLineItemQuantity;
